"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentErrorShortCodes = void 0;
var PaymentErrorShortCodes;

(function (PaymentErrorShortCodes) {
  /* Setup */
  PaymentErrorShortCodes["missing_env"] = "missing_env";
  PaymentErrorShortCodes["missing_vendor_library"] = "missing_vendor_library";
  /* Session */

  PaymentErrorShortCodes["missing_session"] = "missing_session";
  PaymentErrorShortCodes["invalid_session"] = "invalid_session";
  PaymentErrorShortCodes["missing_session_data"] = "missing_session_data";
  PaymentErrorShortCodes["invalid_app_name"] = "invalid_app_name";
  PaymentErrorShortCodes["invalid_encryption_key"] = "invalid_encryption_key";
  PaymentErrorShortCodes["invalid_currency"] = "invalid_currency";
  PaymentErrorShortCodes["session_already_completed"] = "session_already_completed";
  PaymentErrorShortCodes["tokenization_attempts_exceeded"] = "tokenization_attempts_exceeded";
  /* Billing Contact */

  PaymentErrorShortCodes["missing_billing_contact"] = "missing_billing_contact";
  PaymentErrorShortCodes["invalid_first_name"] = "invalid_first_name";
  PaymentErrorShortCodes["invalid_middle_name"] = "invalid_middle_name";
  PaymentErrorShortCodes["invalid_last_name"] = "invalid_last_name";
  PaymentErrorShortCodes["invalid_address_1"] = "invalid_address_1";
  PaymentErrorShortCodes["invalid_address_2"] = "invalid_address_2";
  PaymentErrorShortCodes["invalid_address_3"] = "invalid_address_3";
  PaymentErrorShortCodes["invalid_city"] = "invalid_city";
  PaymentErrorShortCodes["invalid_state"] = "invalid_state";
  PaymentErrorShortCodes["invalid_country"] = "invalid_country";
  PaymentErrorShortCodes["invalid_zip"] = "invalid_zip";
  PaymentErrorShortCodes["invalid_phone"] = "invalid_phone";
  PaymentErrorShortCodes["invalid_email"] = "invalid_email";
  PaymentErrorShortCodes["invalid_ip"] = "invalid_ip_address";
  /* Payment Method */

  PaymentErrorShortCodes["missing_payment_method"] = "missing_payment_method";
  PaymentErrorShortCodes["unsupported_payment_method"] = "unsupported_payment_method";
  PaymentErrorShortCodes["missing_credit_card"] = "missing_credit_card";
  PaymentErrorShortCodes["invalid_card_number"] = "invalid_card_number";
  PaymentErrorShortCodes["invalid_card_number_luhn"] = "invalid_card_number_luhn";
  PaymentErrorShortCodes["invalid_card_security_code"] = "invalid_card_security_code";
  PaymentErrorShortCodes["invalid_card_security_code_length"] = "invalid_card_security_code_length";
  PaymentErrorShortCodes["invalid_expiration_month"] = "invalid_expiration_month";
  PaymentErrorShortCodes["invalid_expiration_year"] = "invalid_expiration_year";
  PaymentErrorShortCodes["invalid_expiration_date_in_the_past"] = "invalid_expiration_date_in_the_past";
  PaymentErrorShortCodes["invalid_name_on_card"] = "invalid_name_on_card";
  PaymentErrorShortCodes["missing_ach"] = "missing_ach";
  PaymentErrorShortCodes["invalid_bank_account_number"] = "invalid_bank_account_number";
  PaymentErrorShortCodes["invalid_bank_routing_number"] = "invalid_bank_routing_number";
  PaymentErrorShortCodes["missing_echeck"] = "missing_echeck";
  PaymentErrorShortCodes["invalid_driver_license_number"] = "invalid_driver_license_number";
  PaymentErrorShortCodes["invalid_driver_license_issuing_state"] = "invalid_driver_license_issuing_state";
  PaymentErrorShortCodes["invalid_check_number"] = "invalid_check_number";
  PaymentErrorShortCodes["missing_epaper_token"] = "missing_epaper_token";
  PaymentErrorShortCodes["invalid_epaper_token"] = "invalid_epaper_token";
  PaymentErrorShortCodes["missing_three_d_secure"] = "missing_three_d_secure";
  PaymentErrorShortCodes["invalid_encrypted_payment_details"] = "invalid_encrypted_payment_details";
  /* Payment Processing */

  PaymentErrorShortCodes["payment_timeout"] = "payment_timeout";
  PaymentErrorShortCodes["invalid_vendor_response"] = "invalid_vendor_response";
  PaymentErrorShortCodes["invalid_card_number_encryption_error"] = "invalid_card_number_encryption_error";
  PaymentErrorShortCodes["session_parsing_error"] = "session_parsing_error";
  PaymentErrorShortCodes["adapter_determination_error"] = "adapter_determination_error";
  PaymentErrorShortCodes["server_session_error"] = "server_session_error";
  PaymentErrorShortCodes["server_tokenization_error"] = "server_tokenization_error";
})(PaymentErrorShortCodes = exports.PaymentErrorShortCodes || (exports.PaymentErrorShortCodes = {}));